import styles from "./useScrollBorder.module.scss";
import { useScrollDetection } from "./useScrollDetection";
export let ScrollBorderPlacement = /*#__PURE__*/function (ScrollBorderPlacement) {
  ScrollBorderPlacement["Header"] = "header";
  ScrollBorderPlacement["Footer"] = "footer";
  ScrollBorderPlacement["Both"] = "both";
  return ScrollBorderPlacement;
}({});

/**
 * Hook that combines scroll detection with border styling logic.
 * Automatically applies border and shadow styling when content is scrollable.
 * For header placement: shows bottom border/shadow when can scroll to top (!isAtTop).
 * For footer placement: shows top border/shadow when not at bottom (scrolled up from bottom).
 * For both placement: returns separate headerClassName and footerClassName for applying to different elements.
 */

export function useScrollBorder(contentRef, placement, baseClassName) {
  let dependencies = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  const {
    hasScroll,
    isAtBottom,
    isAtTop
  } = useScrollDetection(contentRef, dependencies);

  // For header: show when can scroll to top (!isAtTop)
  // For footer: show when not at bottom (!isAtBottom)
  // For both: show header when !isAtTop and footer when !isAtBottom
  const shouldShowHeaderBorder = hasScroll && !isAtTop;
  const shouldShowFooterBorder = hasScroll && !isAtBottom;
  function buildClass(base, active, show, baseClassName) {
    const result = show ? "".concat(base, " ").concat(active) : base;
    return baseClassName ? "".concat(baseClassName, " ").concat(result) : result;
  }
  switch (placement) {
    case ScrollBorderPlacement.Both:
      return {
        headerClassName: buildClass(styles.scrollBorderHeader, styles.scrollBorderHeaderActive, shouldShowHeaderBorder, baseClassName),
        footerClassName: buildClass(styles.scrollBorderFooter, styles.scrollBorderFooterActive, shouldShowFooterBorder, baseClassName),
        hasScroll,
        isAtBottom,
        isAtTop
      };
    case ScrollBorderPlacement.Header:
      {
        return {
          className: buildClass(styles.scrollBorderHeader, styles.scrollBorderHeaderActive, shouldShowHeaderBorder, baseClassName),
          hasScroll,
          isAtBottom,
          isAtTop
        };
      }
    case ScrollBorderPlacement.Footer:
      {
        return {
          className: buildClass(styles.scrollBorderFooter, styles.scrollBorderFooterActive, shouldShowFooterBorder, baseClassName),
          hasScroll,
          isAtBottom,
          isAtTop
        };
      }
  }
}